import { number } from 'prop-types';

const serviceMergeBasicInformationPropTypes = {
  id: number.isRequired,
};

export default serviceMergeBasicInformationPropTypes;
